import React from 'react';

import PropTypes from 'prop-types';

import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { useComplexMessage, usePageMessages } from 'apps/auth/hooks/selectors';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

import BiometricTermsPopup from './BiometricTermsPopup';

const BiometricTerms = ({ onCloseIconClick, popupRef, ...props }) => {
    const { biometricDisclaimerTitle, biometricDisclaimerSubtitle, continueButton, biometricDisclaimerPolicyButton, biometricDisclaimerPolicyLink } =
        usePageMessages();
    const { biometricDisclaimerBody } = useComplexMessage();

    return (
        <CommonPage
            leftCloseIcon
            hasBottomPanel
            backUrl={AUTH_SEND_MAIN_LINK}
            onClickIcon={(e) => {
                e.preventDefault();
                onCloseIconClick();
            }}
        >
            <HeaderPanel title={biometricDisclaimerTitle} />
            <Text variant="paragraph">{biometricDisclaimerSubtitle}</Text>
            <Row indent="adaptive-16-24">
                <Button
                    caption={biometricDisclaimerPolicyButton}
                    type={'link'}
                    variant="row"
                    href={biometricDisclaimerPolicyLink}
                    target="_blank"
                    negativeMargin
                />
            </Row>
            {MarkdownService.parseComplexMessage(biometricDisclaimerBody)}
            <FixedBottomPanel isRightAligned>
                <Button
                    caption={continueButton}
                    type={'link'}
                    variant={'primary'}
                    onClick={(e) => {
                        e.preventDefault();
                        popupRef?.current?.open(<BiometricTermsPopup popupRef={popupRef} onContinueIntro={props.onContinueIntro} />);
                    }}
                />
            </FixedBottomPanel>
        </CommonPage>
    );
};
BiometricTerms.propTypes = {
    onCloseIconClick: PropTypes.func.isRequired,
    onContinueIntro: PropTypes.func.isRequired,
    popupRef: PropTypes.object.isRequired,
};
export default BiometricTerms;
